import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 入所者募集・待機者管理サービスプラン API 操作クラス
 */
export default class WaiterServicePlans {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET WaiterServicePlans
   */
  public async gets(userStore: LoginUser): Promise<Array<WaiterServicePlansGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.WaiterServicePlans, formatParams);
    const response = await this.commonService.executeGet<Array<WaiterServicePlansGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * ### プラン
 */
export interface WaiterServicePlansGetModel {
  /** プラン種別 */
  type: WaiterServicePlanType;
  /** プラン名 */
  name: string;
  /** 料金 */
  price: number;
  /** コネクトセット料金 */
  priceHitomeqConnectSet: number;
}

/**
 * ### プラン種別
 */
export enum WaiterServicePlanType {
  UNKNOWN = -1,
  FREE = 0,
  BASIC = 1,
  ENTERPRISE = 2
}
